import React from 'react';
import { soldermask as tooltip } from 'pu-data/Tooltips';
import {
  solderSide as defaultSidesOptions,
  solderColor as defaultColorOptions,
} from 'pu-data/SelectOptions';
import SelectDualComponent from './SelectDualComponent';

const Soldermask = props => (
  <SelectDualComponent
    {...props}
    label="Soldermask"
    required={props.required}
    tooltip={tooltip}
    nameA="solder_sides"
    defaultOptionsA={props.sidesOptions}
    nameB="solder_color"
    defaultOptionsB={props.colorOptions} />
);

Soldermask.defaultProps = {
  sidesOptions: defaultSidesOptions,
  colorOptions: defaultColorOptions,
  required    : true,
};

export default Soldermask;
